import styled from "styled-components";

export const StyledSection = styled.section`
  background-color: #ffffff;
  width: 100%;
  padding: 100px 48px 60px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;

  @media ${({ theme }) => theme.media.mobile} {
    max-width: 100%;
    padding: 60px 0.8rem 20px;
    gap: 40px;
  }
`;

export const Heading = styled.h2`
  color: rgba(29, 29, 29, 0.85);
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 44px;
  font-weight: 500;
  line-height: 1.3;
  letter-spacing: -0.02em;
  align-self: center;
  max-width: 100%;
  margin: 0 auto;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 28px;
    line-height: 1.3;
    letter-spacing: unset;
  }
`;

export const HeadingHighlight = styled.span`
  color: rgba(29, 29, 29, 0.5);
  font-family: inherit;
`;

export const ArticleGrid = styled.div`
  display: grid;
  grid-gap: 60px 16px;
  gap: 60px 16px;
  grid-template-columns: repeat(3, 1fr);

  @media ${({ theme }) => theme.media.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${({ theme }) => theme.media.mobile} {
    grid-template-columns: 1fr;
    grid-gap: 40px;
    gap: 40px;
  }
`;

export const ViewAllBtn = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  isolation: isolate;
  background-color: #1d1d1d;
  border-radius: 12px;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
  width: fit-content;
  cursor: pointer;
  box-shadow: none;
  outline: none;
  border: none;
  transition: background-color, opacity 0.3s ease;
  position: relative;
  overflow: hidden;
  z-index: 1;

  &:hover {
    // background-color: rgba(29, 29, 29, 0.85);
    opacity: 0.85;
  }

  &::before {
    /* Blur */

    content: "";

    position: absolute;
    height: 55.57px;
    left: 8.81%;
    right: 8.81%;
    top: 38.26px;

    background: #fc714a;
    opacity: 0.3;
    filter: blur(16px);
    border-radius: 59.0555px;

    z-index: 0;
  }

  img {
    width: 20px;
    height: 20px;
  }

  @media ${({ theme }) => theme.media.mobile} {
  }
`;
